import m from "../../prime-src/prepare";
import $ from 'jquery';
import { useState, useEffect, useRef } from "react";
import { EveEvent } from "../types/types";

export default function GoogleSearch() {
  const [text, setText] = useState('');
  const ignore = useRef(false);

  function initialEffect() {
    m.$textarea_gs = $("#textarea-gs");
    m.$button_gs = $("#button-gs");
    m.$textarea_gs.on("keydown.gs", function (e: Event) {
      if ((e as EveEvent).code === "Enter") {
        e.preventDefault();
        m.$button_gs.trigger("click.gs");
      }
    });
  }

  useEffect(() => {
    if (!ignore.current) {
      initialEffect();
    }

    return () => {
      ignore.current = true;
    };
  }, []);

  return (
    <div className="side2" id="google-search">
      <textarea id="textarea-gs" className="fLeft" value={text} onChange={(e) => setText(e.target.value)}></textarea>
      <div id="button-gs" className="button fLeft" onClick={() => {
        window.open(
          `http://www.google.com/search?q=${encodeURIComponent( `site:recoeve.net${m.userPath} ${text}`)}`,
          "_blank"
        );
      }}>Google Search</div>
      <div className="cBoth" style={{padding:'.5em'}}></div>
    </div>
  );
}
